import axios from 'utils/axios';
import { each } from 'lodash';

import { VITALS_RANGE_PRESETS } from 'utils/vitalsData';

// eslint-disable-next-line no-unused-vars
export async function getVitalsDataMeta(patientId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/vitals/meta`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

// The server resolves the range in the app zone: a preset (LAST_14_DAYS /
// LAST_30_DAYS) or a custom inclusive from/to in YYYY-MM-DD. The response
// carries the readings in range (`vitalsData`), the resolved `range`, the
// `summary`, the device legend and the alert-tolerance `referenceLines`.
export async function getVitalsData(patientId, type, { preset, from, to } = {}) {
    try {
        const params = { type };
        if (from && to) {
            params.from = from;
            params.to = to;
        } else if (preset && preset !== VITALS_RANGE_PRESETS.CUSTOM) {
            // Custom without both dates falls back to the server default
            params.preset = preset;
        }
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/vitals/data`, {
            params
        });

        each(response.data.vitalsData, (vitalsEntry) => {
            vitalsEntry.readingTime = vitalsEntry.readingTime ? new Date(vitalsEntry.readingTime).getTime() : '';
        });

        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function getVitalsDevices(patientId) {
    try {
        const response = await axios.get(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/vitals/devices`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function deleteVitalsDevice(patientId, deviceId) {
    try {
        const response = await axios.delete(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/vitals/devices/${deviceId}`);
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}

export async function addVitalsDevice(patientId, deviceId, vitalsProviderName) {
    try {
        const response = await axios.post(`/api/org-id/{orgId}/clinic-id/{clinicId}/patient/${patientId}/vitals/devices/add`, {
            deviceId,
            vitalsProviderName
        });
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            return e;
        }
        return {
            message: 'unknown error'
        };
    }
}
